module.exports = __webpack_public_path__ + "img/mentorshipFlow.1b74cc8a.jpg";